import { createFileRoute, redirect } from '@tanstack/react-router';

import { USER_QUERY_KEYS } from '@/features/user/data/query-keys';
import { userApi } from '@/features/user/data/user-api';
import { queryClient } from '@/query-client';
import { API_URL, APP_URL } from '@/utils/environment';
import { buildHead } from '@/utils/html';

export const Route = createFileRoute('/login/')({
  beforeLoad: async () => {
    // tries to get the user without redirection on 401
    const user = await tryGetUser();

    // preload in cache so the authenticated layout does not refetch & redirect
    if (user === undefined) {
      globalThis.location.replace(`${API_URL}/api/v1/web/auth/login?redirectUri=${APP_URL}`);
    } else {
      queryClient.setQueryData(USER_QUERY_KEYS.user(), user);
      throw redirect({ to: '/projects' });
    }
  },
  head: () => buildHead('login'),
});

async function tryGetUser() {
  try {
    return await userApi.tryGet();
  } catch (error) {
    // user is not authenticated, an error will be thrown. Silently catching it lets the user proceed to the login page
    if (error) {
      return;
    }
    return;
  }
}
